import { TreeStore } from "@react-awesome-query-builder/core";
export default TreeStore;